import { render, staticRenderFns } from "./q10.vue?vue&type=template&id=4f3db8e7&scoped=true&"
import script from "./q10.vue?vue&type=script&lang=js&"
export * from "./q10.vue?vue&type=script&lang=js&"
import style0 from "./q10.vue?vue&type=style&index=0&id=4f3db8e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3db8e7",
  null
  
)

export default component.exports